/**
 * 痛みレベルと苦悶レベルから腐敗レベルを算出
 * @param painLevel 痛みレベル (0-100)
 * @param sufferingLevel 苦悶レベル (0-100)
 * @returns 腐敗レベル (0-100)
 */
export function calculateCorruptionLevel(painLevel: number, sufferingLevel: number): number {
  // 痛みベースで苦悶が増幅効果
  // 苦悶100で2倍の増幅効果
  // 痛み75 & 苦悶60で腐敗レベル100に達する
  return Math.min(100, painLevel * (1 + sufferingLevel / 150))
}